import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import NotificacoesVagas from './NotificacoesVagas';
import useAuthStore from '../store/authStore';

export default function Layout({ children, title, subtitle }) {
  const { user } = useAuthStore();
  const isCandidato = user?.tipo === 'candidato';

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1 md:ml-56">
        {/* Mobile navbar */}
        <div className="md:hidden">
          <Navbar />
        </div>
        <main className="p-4 md:p-6 max-w-5xl">
          {(title || subtitle) && (
            <div className="mb-6">
              {title    && <h1 className="page-header">{title}</h1>}
              {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
            </div>
          )}
          {children}
        </main>
      </div>
      {/* Notificações de vagas – apenas para candidatos */}
      {isCandidato && <NotificacoesVagas />}
    </div>
  );
}
